import { ItemMessageBase } from 'src/app/shared/models/itemmessagebase.model';

export class InputValue extends ItemMessageBase {
  id: number;
  inputQuantityBalance = 0;
  inputValueBalance = 0;
  inputCurrency: string;
  unitOfMeasure: string;
}
